<template>
	<div class="content">
		<div class="title">
			
		</div>
		
	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui';
	export default {
		data() {
			return {
				index: 'examination',
				hasLogin: false,
				userInfo: '',
				id: '',
				detail:'',
			}
		},
		filters: {
			subStringTime(str) {
				return str.substring(0, 10);
			}
		},
		created() {
			//获取登录用户信息
			// this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
			// if (this.userInfo != null && this.userInfo != undefined) {
			// 	this.hasLogin = true;
			// }
			this.id = this.$route.query.id;
			this.getDetail();
		},
		methods: {
			//查询内容
			getDetail() {
				this.$get('/blade-desk/notice/detail', {id: this.id})
					.then((res) => {
						console.log(res);
						if (res.code == '200') {
							this.detail = res.data;
							//通知消息已读 
							this.$get('/blade-desk/notice/read', {id: this.id})
								.then(resp => {
									console.log(resp)
								})
						} else {
							this.$message({
								message: res.msg,
							});
						}
					})
			},
		}
	}
</script>

<style scoped lang="less">
	.content{
		background-color: #EBEFF1;padding-bottom: 0.3rem;padding-left: 1.2rem;padding-right: 1.2rem;
	}
	.title{
		width: 12rem;height: 0.6rem;color: #000000;font-size: 0.15rem;font-weight: 400;font-family: Alibaba PuHuiTi;
		display: flex;align-items: center;
	}
	.title span:first-child{
		color: #cccccc;
	}
	
</style>



// WEBPACK FOOTER //
// src/index/examination.vue